import { defineAsyncComponent } from "vue";
import { createFieldInputNumber } from "../../../../../components/input/template-builder/template-builder.logic";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import lodash from "lodash";
import i18n from "../../../../../i18n";

const StorageLocationSubList = defineAsyncComponent(() => import("./StorageLocationSubList"));

export const callStorageLocationSubType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "STORAGE_LOCATION_SUB_TYPE", value: searchQuery });

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}subs`,
                            fetchCriteria: data.sub?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "StorageLocationSubList" } })
                    );
                    return <StorageLocationSubList {...componentProp}></StorageLocationSubList>;
                }
            },
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("views.request.storageLocationSub.sumUseCapacity"),
                inputProp: ({ field }) => {
                    const sum = model.subs
                        .filter(d => d.isDelete !== true && d.useCapacity?.toString().length > 0)
                        .map(d => parseFloat(d.useCapacity))
                        .reduce((accumulator, current) => accumulator + current, 0);
                    return lodash.merge(
                        {
                            value: sum,
                            disabled: true,
                            allowPrecision: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("views.request.storageLocationSub.sumTotalCapacity"),
                inputProp: ({ field }) => {
                    const sum = model.subs
                        .filter(d => d.isDelete !== true && d.totalCapacity?.toString().length > 0)
                        .map(d => parseFloat(d.totalCapacity))
                        .reduce((accumulator, current) => accumulator + current, 0);
                    return lodash.merge(
                        {
                            value: sum,
                            disabled: true,
                            allowPrecision: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            })
        ]
    });
};
